export default __webpack_public_path__ + "static/meet-john-3-cbe98d6db6be3ff7e322578de831b159.webp";